module.exports = __webpack_public_path__ + "static/media/default-dark.34149eef.png";